Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PreviewUpdateButton = void 0;

var core_1 = require("@emotion/core");

var spinner_1 = require("./spinner");

var react_1 = require("react");

var admin_core_1 = require("@wheelroom/admin-core");

var getters_1 = require("../getters");

exports.PreviewUpdateButton = function () {
  var _react_1$useContext = react_1.useContext(admin_core_1.AdminCoreContext),
      adminCoreState = _react_1$useContext.adminCoreState;

  var store = getters_1.getPreviewPageStore(adminCoreState);

  if (!store) {
    return null;
  }

  var pagePreviewState = store.state;

  if (!pagePreviewState.inPreviewMode) {
    return null;
  }

  var fetch = function fetch() {
    store.actions.fetchPage(adminCoreState);
  };

  return core_1.jsx("div", {
    role: "button",
    "aria-label": "Update preview content",
    onClick: fetch,
    css: {
      backdropFilter: 'saturate(180%) blur(20px)',
      backgroundColor: 'rgba(255,255,255,0.3)',
      boxShadow: 'rgba(0,0,0,0.3) 0 0 6px, rgba(0,0,0,0.15) 0 1px 6px',
      border: '1px solid rgba(255,255,255,.5)',
      borderRadius: '10px',
      cursor: 'pointer',
      fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
      fontSize: '16px',
      color: '#222',
      position: 'fixed',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      right: '24px',
      bottom: '16px',
      height: '48px',
      width: '160px'
    }
  }, store.state.isFetching ? core_1.jsx(spinner_1.Spinner, null) : 'Update preview');
};